import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-18">
        {/* Logo */}
        <div className="flex items-center cursor-pointer" onClick={() => scrollTo("hero")}>
          <img
            src="https://storage.readdy-site.link/project_files/56c41bf3-601b-4bf6-887a-7e03952d5d2d/218c8f37-84c2-4ce1-83b2-289940c337c2_logo.png?v=23227280e2aecf228e7afc5646e19210"
            alt="Hongguo Drama"
            className="h-10 w-auto object-contain"
          />
        </div>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: "ฟีเจอร์", id: "features" },
            { label: "วิธีรับรางวัล", id: "earn" },
            { label: "รีวิว", id: "testimonials" },
            { label: "FAQ", id: "faq" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? "text-gray-600 hover:text-red-500" : "text-white/90 hover:text-white"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA Button */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => scrollTo("download")}
            className="hidden md:flex items-center gap-2 bg-gradient-to-r from-red-500 to-orange-400 text-white px-5 py-2 rounded-full text-sm font-semibold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap shadow-lg shadow-red-500/30"
          >
            <i className="ri-download-line"></i>
            ดาวน์โหลด
          </button>
          {/* Mobile hamburger */}
          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? "text-gray-800" : "text-white"}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
          {[
            { label: "ฟีเจอร์", id: "features" },
            { label: "วิธีรับรางวัล", id: "earn" },
            { label: "รีวิว", id: "testimonials" },
            { label: "FAQ", id: "faq" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-left text-gray-700 font-medium py-2 border-b border-gray-50 cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("download")}
            className="mt-2 bg-gradient-to-r from-red-500 to-orange-400 text-white py-3 rounded-full font-semibold cursor-pointer whitespace-nowrap"
          >
            ดาวน์โหลดเลย
          </button>
        </div>
      )}
    </nav>
  );
}
